<template>
    <div>
        <Breadcrumb section-name="Customer" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-header">
                    <h5 class="card-title text-center mt-2">Customer Information From</h5>
                </div>
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <form @submit.prevent="handleSubmit">
                        <div class="container">
                            <div class="row">
                                <div class="col-sm-12">
                                    <template v-if="!photo">
                                        <input @change="addPhoto" id="fancy-file-upload" type="file"
                                               name="files" accept=".jpg, .png, image/jpeg, image/png"
                                               class="d-none">
                                        <label for="fancy-file-upload" class="file-upload avatar">Photo</label>
                                    </template>
                                    <template v-if="photo">
                                        <div class="position-relative w-content">
                                            <img class="avatar" :src="photo" alt="">
                                            <div class="remove-avatar bg-danger" @click="removePhoto">
                                                <i class="bx bx-trash"></i>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <!-- Name -->
                                <div class="col-md-6 mb-3 form-group">
                                    <label for="name" class="form-label">Name</label>
                                    <input type="text" name="name" v-model="form.name" class="form-control">
                                    <div class="invalid-feedback"></div>
                                </div>

                                <!-- Area -->
                                <div class="col-md-6 mb-3">
                                    <label for="area_id" class="form-label">Area</label>
                                    <select class="form-control" name="area_id" v-model="form.area_id">
                                        <option value=""></option>
                                        <option v-for="each in areas" v-text="each.area_name" :value="each.id"></option>
                                    </select>
                                </div>

                                <!-- Present Address -->
                                <div class="col-md-6 mb-3">
                                    <label for="present_address" class="form-label">Present Address</label>
                                    <textarea id="present_address" v-model="form.present_address" class="form-control" rows="3"></textarea>
                                </div>

                                <!-- Permanent Address -->
                                <div class="col-md-6 mb-3">
                                    <label for="permanent_address" class="form-label">Permanent Address</label>
                                    <textarea id="permanent_address" v-model="form.permanent_address" class="form-control" rows="3"></textarea>
                                </div>

                                <!-- Mobile No -->
                                <div class="col-md-6 mb-3">
                                    <label for="mobile_no" class="form-label">Mobile No</label>
                                    <input type="tel" id="mobile_no" v-model="form.mobile_no" class="form-control">
                                </div>

                                <!-- WhatsApp No -->
                                <div class="col-md-6 mb-3">
                                    <label for="whatsapp_no" class="form-label">WhatsApp No</label>
                                    <input type="tel" id="whatsapp_no" v-model="form.whatsapp_no" class="form-control">
                                </div>

                                <!-- Project Name -->
                                <div class="col-md-6 mb-3">
                                    <label for="project_id" class="form-label">Project</label>
                                    <select class="form-control" name="project_id" v-model="form.project_id">
                                        <option value=""></option>
                                        <option v-for="each in projects" v-text="each.name" :value="each.id"></option>
                                    </select>
                                </div>

                                <!-- Interest -->
                                <div class="col-md-6 mb-3">
                                    <label for="interest_id" class="form-label">Interest</label>
                                    <select class="form-control" name="interest_id" v-model="form.interest_id">
                                        <option value=""></option>
                                        <option v-for="each in interests" v-text="each.name" :value="each.id"></option>
                                    </select>
                                </div>

                                <!-- Contract Date -->
                                <div class="col-md-6 mb-3 form-group position-relative">
                                    <label for="contract_date" class="form-label">Contract Date</label>
                                    <flat-pickr class="form-control" v-model="form.contract_date" name="date_of_birth"
                                                :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                    <i class="bx bx-calendar calendar-icon"></i>
                                </div>

                                <!-- Contract From -->
                                <div class="col-md-6 mb-3">
                                    <label for="contact_id" class="form-label">Contract From</label>
                                    <select class="form-control" name="contact_id" v-model="form.contact_id">
                                        <option value=""></option>
                                        <option v-for="each in contacts" v-text="each.name" :value="each.id"></option>
                                    </select>
                                </div>

                                <!-- Project Visit Date -->
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <td>Project Visit Date</td>
                                            <td>Remarks</td>
                                            <td>Action</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(each,index) in form.details">
                                            <td>
                                                <flat-pickr class="form-control" v-model="each.project_visit_date" name="date_of_birth"
                                                            :config="{dateFormat: 'Y-m-d', altInput: true, altFormat:'d/m/Y'}"/>
                                            </td>
                                            <td>
                                                <input id="remarks" v-model="each.remarks" class="form-control">
                                            </td>
                                            <td>
                                                <button type="button" v-if="index === 0" @click="addMore" class="btn btn-primary">+</button>
                                                <button type="button" v-if="index !== 0" @click="removeMore(index)" class="btn btn-danger">x</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Buttons -->
                        <div class="text-end">
<!--                            <router-link :to="{name: 'employee'}" type="button" class="btn btn-secondary me-2 btn-width">Close</router-link>-->
                            <button type="submit" class="btn btn-primary btn-width me-2" v-if="!loading">
                                Save
                            </button>
                            <button type="button" class="btn btn-primary btn-width" v-if="loading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb.vue";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";
import Table from "../Common/Table.vue";

export default {
    components: {Table, Breadcrumb },
    data() {
        return {
            breadCrumb: ['Add'],
            loading: false,
            dataLoading: false,
            form: {
                name: '',
                present_address: '',
                permanent_address: '',
                area_id: '',
                mobile_no: '',
                whatsapp_no: '',
                project_id: '',
                interest_id: '',
                contract_date: '',
                contact_id: '',
                project_visit_date: '',
                remarks: '',
                image: '',
                details: [
                    {
                        project_visit_date: '',
                        remarks: ''
                    }
                ]
            },
            projects: [],
            interests: [],
            contacts: [],
            areas: [],
            photo: null,
        };
    },
    methods: {
        removeMore(index) {
            this.form.details.splice(index, 1);
        },
        addMore() {
            this.form.details.push({
                project_visit_date: '',
                remarks: ''
            });
        },
        removePhoto: function () {
            this.form.image = '';
            this.photo = null;
        },
        addPhoto: function (e) {
            this.form.image = e.target.files[0];
            this.photo = URL.createObjectURL(this.form.image);
        },
        fetchArea: function() {
            ApiService.POST(ApiRoutes.ListArea, {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.areas = res.data.data;
                }
            });
        },
        fetchContact: function() {
            ApiService.POST(ApiRoutes.Contact + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.contacts = res.data.data;
                }
            });
        },
        fetchInterest: function() {
            ApiService.POST(ApiRoutes.Interest + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.interests = res.data.data;
                }
            });
        },
        fetchProject: function() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        handleSubmit() {
            ApiService.ClearErrorHandler();
            this.loading = true;
            let param = this.makeFormData(this.form)
            ApiService.POST(ApiRoutes.Customer + '/save', param, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message);
                    this.form = {
                        name: '',
                        present_address: '',
                        permanent_address: '',
                        area_id: '',
                        mobile_no: '',
                        whatsapp_no: '',
                        project_id: '',
                        interest_id: '',
                        contract_date: '',
                        contact_id: '',
                        project_visit_date: '',
                        remarks: '',
                        image: '',
                    };
                    this.photo = null;
                } else {
                    ApiService.ErrorHandler(res.errors);
                }
            });
        },
    },
    mounted() {
        this.fetchProject();
        this.fetchInterest();
        this.fetchContact();
        this.fetchArea();
    }
};
</script>

<style scoped>
/* Add custom styles here if needed */
</style>
